module.exports = __webpack_public_path__ + "media/images/lb/728-99a9a1119f93f4ecff2ddc853dfa3a5e.svg";